import liff from '@line/liff'
import store from '@/store'
import VConsole from 'vconsole';

const GUEST_SESSION_KEY = 'tongxin_is_guest'
const liffId = () => process.env.VUE_APP_LIFF_ID || store.state.liffGeneral.moduleConfig.liff_id_tongxin || store.state.liffGeneral.moduleConfig.liff_id
const OAUTH_CALLBACK_QUERY_KEYS = ['code', 'state', 'liffClientId', 'liffRedirectUri']

const hasGuestSession = () => {
  try {
    return sessionStorage.getItem(GUEST_SESSION_KEY) === '1'
  } catch (error) {
    console.warn('[tongxinCheckWeb] failed to read guest session:', error)
    return false
  }
}

async function waitForRedirect() {
  return new Promise(() => {}); // use a infinite hang to wait for redirect
}

function buildTongxinRedirectUri(orgCode, savedLiffState) {
  var currentUrl = new URL(window.location.href)
  OAUTH_CALLBACK_QUERY_KEYS.forEach(function (key) {
    currentUrl.searchParams.delete(key)
  })

  if (!savedLiffState) {
    return currentUrl.toString()
  }

  try {
    // savedLiffState 形如 "/step/exam-selection?clinicCode=CPW"，以 / 開頭
    // 不能用 new URL(savedLiffState, base)，會被當成 origin-relative 而丟掉 base 的 pathname
    var basePath = window.location.origin + '/' + orgCode + '/web/proj/tongxin'
    var parsedStateUrl = new URL(basePath + savedLiffState)
    var mergedParams = new URLSearchParams(parsedStateUrl.search)
    currentUrl.searchParams.forEach(function (value, key) {
      mergedParams.set(key, value)
    })
    parsedStateUrl.search = mergedParams.toString()
    return parsedStateUrl.toString()
  } catch (error) {
    return currentUrl.toString()
  }
}

async function retrieveWipUser(lineAccessToken) {
  store.commit("liffAuth/SET_TOKEN", lineAccessToken);

  if (!store.state.liffAuth.user.name) {
    try {
      await store.dispatch('liffAuth/fetchMe');
    } catch (error) {
      console.warn('fetchMe failed, possibly due to expired token', error);
      const removeItems = ['context', 'IDToken', 'clientId', 'accessToken', 'decodedIDToken'];
      removeItems.forEach(async (item) => {
        await localStorage.removeItem(`LIFF_STORE:${liffId()}:${item}`);
      });
      // token 壞掉，重新走 LINE OAuth
      liff.login({ redirectUri: window.location.href })
      await waitForRedirect()
    }
  }
}

export default async function tongxinCheckWeb({ next, to, from }) {
  if (to.query['vconsole']) {
    new VConsole({ theme: 'dark' });
  }

  console.log('[tongxinCheckWeb] window.location.href:', window.location.href)
  console.log('[tongxinCheckWeb] to.path:', to.path)
  console.log('[tongxinCheckWeb] to.query:', JSON.stringify(to.query))
  console.log('[tongxinCheckWeb] from.name:', from.name)

  // 判斷是否為首次進入（整頁載入），還是 SPA 內部導航
  const isSpaNavigation = !!from.name
  const hasGuestSessionLocked = hasGuestSession()

  if (to.query.from === 'web') {
    // URL 明確帶 from=web → 設為訪客模式
    store.dispatch('web/tongxin/setGuest', true);
  } else if (hasGuestSessionLocked) {
    // 同一個 tab / webview session 內，沿用既有 guest 狀態（含 reload）
    store.dispatch('web/tongxin/setGuest', true);
  } else if (isSpaNavigation) {
    // SPA 內部導航（例如 step 之間切換）→ 維持現有狀態，不重新判斷
    // 避免因為 $router.push 沒帶 query 而重置 guest 或觸發 LINE 登入
  } else {
    // 首次進入頁面（例如從 LINE 選單直接開啟）且沒有 from=web → 需要 LINE 登入
    store.dispatch('web/tongxin/setGuest', false);

    // 從 window.location 移除 liff.state，防止 LIFF SDK 在 liff.init() 時自動轉導
    // SDK 看到 liff.state 會做整頁轉導（到該 liff_id 的 endpoint），導致認證 context 遺失
    var savedLiffState = null
    if (new URL(window.location.href).searchParams.has('liff.state')) {
      savedLiffState = new URL(window.location.href).searchParams.get('liff.state')
      var cleanUrl = new URL(window.location.href)
      cleanUrl.searchParams.delete('liff.state')
      console.log('[tongxinCheckWeb] replaceState to remove liff.state:', cleanUrl.toString())
      history.replaceState(null, '', cleanUrl.toString())
    }

    console.log('[tongxinCheckWeb] liffId():', liffId())
    await liff.init({ liffId: liffId() })
    console.log('[tongxinCheckWeb] liff.isLoggedIn():', liff.isLoggedIn())

    if (!liff.isLoggedIn()) {
      // LINE OAuth 沒登入 → 用 liff.login() 觸發該 LIFF app 的 OAuth
      // redirectUri 保留目前路徑與 query，避免 clinicCode/sourceType 在登入後遺失
      var orgCode = to.params.org_code
      var redirectUri = buildTongxinRedirectUri(orgCode, savedLiffState)
      console.log('[tongxinCheckWeb] liff.login() redirectUri:', redirectUri)
      liff.login({ redirectUri: redirectUri })
      await waitForRedirect()
    }

    var token = liff.getAccessToken()
    console.log('[tongxinCheckWeb] token:', token ? 'has token' : 'null')
    await retrieveWipUser(token);
    console.log('[tongxinCheckWeb] user registered_at:', store.state.liffAuth.user?.registered_at)
  }

  return next();
}
